
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as AboutSchoolSectionKr2i7CsOjrF5g3YVBoneSAkkfPr5K1HA1GpElrgEcUUMeta } from "/app/app/pages/schools/components/AboutSchoolSection.vue?macro=true";
import { default as AboutTrainerSectionVrwfKVKBU6UH47WqeHDaiwx_wvnwSzjvEEqOiG5EzOwMeta } from "/app/app/pages/trainers/components/AboutTrainerSection.vue?macro=true";
import { default as cookie2GskwtYTATB89q7cglhg_qw18NkfFgkjhZCmAYVnlE0Meta } from "/app/app/pages/documents/cookie.vue?macro=true";
import { default as personal_45data8a8jB9Lv9D_1bIu_gkx8jFaBMGSRwbTzzZeA2IrFVJsMeta } from "/app/app/pages/documents/personal-data.vue?macro=true";
import { default as privacy8u0DwJrYwd01csApVo1qyhUh8UrvJzXjzLBG3VULu54Meta } from "/app/app/pages/documents/privacy.vue?macro=true";
import { default as _91id_93VYgDTAYzTCS_ImYrKkHE6PQlcLgd8Ecd7vof_ZGukVkMeta } from "/app/app/pages/directions/[id].vue?macro=true";
import { default as _91id_93TYg8epJyo8GnaTJr77FwtFLPL1O0xx2qg443OLCgy14Meta } from "/app/app/pages/news/[id].vue?macro=true";
import { default as competitionsx9Go7_vZRLE1vd5KEeSGU2Ma_qiLYHtm2U6U8DxUYdIMeta } from "/app/app/pages/schools/[id]/competitions.vue?macro=true";
import { default as contactspiNm3T5uGuQzWFH3dWkJvFpIm5RnYj5ANjKGJ5F0A8gMeta } from "/app/app/pages/schools/[id]/contacts.vue?macro=true";
import { default as directionsg8T3Ecw8KA1_hC9uA_ih__WFAMM8APxfFXww9gc2hdwMeta } from "/app/app/pages/schools/[id]/directions.vue?macro=true";
import { default as newsCWaaHLVCBgSth4GdHa61dimbZdt39pLGk3yogX4aVtwMeta } from "/app/app/pages/schools/[id]/news.vue?macro=true";
import { default as our_45prideCK2kBwvPjo4OO1bTD1NpG8YxtuJNkf0DmgFBF46isWgMeta } from "/app/app/pages/schools/[id]/our-pride.vue?macro=true";
import { default as reviewsQTphlbgAZ6KAm9q0vpLApwN7EG1GMZeOQeX5UPHDjqMMeta } from "/app/app/pages/schools/[id]/reviews.vue?macro=true";
import { default as scheduleM0MGg_uz1iNhM3QRDURq_4nDD7_S54YOAAaNiZLotsAMeta } from "/app/app/pages/schools/[id]/schedule.vue?macro=true";
import { default as trainerstGYyVi0rLX0HcVCXvYZHwHlhbRNYiI6ojGcYovD2Rv8Meta } from "/app/app/pages/schools/[id]/trainers.vue?macro=true";
import { default as indexIcsrfd4FA88t0GfWuw6yZRbVCFjXHlWPlqsOEyZNS50Meta } from "/app/app/pages/schools/[id]/index.vue?macro=true";
import { default as _91id_93EK6Hr25n1MsRwhbZdH3GTKU_PFYvBBOhBvYmJBWLPBAMeta } from "/app/app/pages/schools/[id].vue?macro=true";
import { default as competitionsNnq8OdrF2T1_Es3_UG87uDejE6neU2cbFa9dVKGNLQQMeta } from "/app/app/pages/trainers/[id]/competitions.vue?macro=true";
import { default as contactsrpeeY0dh7ZgWZZgNnoKf6N1S9hjYqYPsiyxbeyVfSAUMeta } from "/app/app/pages/trainers/[id]/contacts.vue?macro=true";
import { default as directionsQ70__MeZYFq6DoZpYGNk_VOtKDSz8JRc1moSuzW4yUAMeta } from "/app/app/pages/trainers/[id]/directions.vue?macro=true";
import { default as newsB7tV_d3aJzW5XmZuGD2Tcx9K3YGJ7PJQ2JZAe7HXbAoMeta } from "/app/app/pages/trainers/[id]/news.vue?macro=true";
import { default as our_45pride5Bf06hzq8iH4exWhMZB_uSWTkKOwDBuBOfAxERT_rTsMeta } from "/app/app/pages/trainers/[id]/our-pride.vue?macro=true";
import { default as reviewsOWOPwaQ569DwqLg8TjUITIffdk76xsCzBECssC2sgtkMeta } from "/app/app/pages/trainers/[id]/reviews.vue?macro=true";
import { default as scheduleZdJ2SjYvheF2BiTf_g_kKKaQacGPduvBrOyRTw8cpo8Meta } from "/app/app/pages/trainers/[id]/schedule.vue?macro=true";
import { default as schoolsiqfhgA8Ou6eV2D315kSSdKQtGc67eY4d1tXhOiMJhVQMeta } from "/app/app/pages/trainers/[id]/schools.vue?macro=true";
import { default as index9aMDwEnpGVuWFW5N1ldnjl8gT18YnCrUMi0l7O98w4AMeta } from "/app/app/pages/trainers/[id]/index.vue?macro=true";
import { default as _91id_93JgY_Uh5_rxQnr2Eilk0lfHSnM__jjtiV3pQ0Vsw5IbsMeta } from "/app/app/pages/trainers/[id].vue?macro=true";
import { default as index8e72ZGJjPgiJMgiXDaIuh7et8YTK5_M4BzWIYum5vQ8Meta } from "/app/app/pages/directions/index.vue?macro=true";
import { default as index0vzPtFuUGDClUpww6atMNzl_Qut4EoVknbd44sNBQpUMeta } from "/app/app/pages/documents/index.vue?macro=true";
import { default as indexXMhUAiv3h8Yn9KnrusHDrXg_4CaqSc0YcZdd_ACZy8cMeta } from "/app/app/pages/news/index.vue?macro=true";
import { default as indexYHDwlvR2vM4IK9S9aO_lNVjj64cOWSOz0gI_D0ogHjQMeta } from "/app/app/pages/schools/index.vue?macro=true";
import { default as index5lW_HNdiZ7SeEpDqsYrYEJZucehb7R3AyTcl1Kj5qTEMeta } from "/app/app/pages/trainers/index.vue?macro=true";
import { default as index4nVS2Dd4a5t9zrU2j8coCxsqtPYupm_GEv_2EzeGhJUMeta } from "/app/app/pages/index.vue?macro=true";
export default [
  {
    name: "schools-components-AboutSchoolSection",
    path: "/schools/components/AboutSchoolSection",
    component: () => import("/app/app/pages/schools/components/AboutSchoolSection.vue")
  },
  {
    name: "trainers-components-AboutTrainerSection",
    path: "/trainers/components/AboutTrainerSection",
    component: () => import("/app/app/pages/trainers/components/AboutTrainerSection.vue")
  },
  {
    name: "documents-cookie",
    path: "/documents/cookie",
    meta: cookie2GskwtYTATB89q7cglhg_qw18NkfFgkjhZCmAYVnlE0Meta || {},
    component: () => import("/app/app/pages/documents/cookie.vue")
  },
  {
    name: "documents-personal-data",
    path: "/documents/personal-data",
    meta: personal_45data8a8jB9Lv9D_1bIu_gkx8jFaBMGSRwbTzzZeA2IrFVJsMeta || {},
    component: () => import("/app/app/pages/documents/personal-data.vue")
  },
  {
    name: "documents-privacy",
    path: "/documents/privacy",
    meta: privacy8u0DwJrYwd01csApVo1qyhUh8UrvJzXjzLBG3VULu54Meta || {},
    component: () => import("/app/app/pages/documents/privacy.vue")
  },
  {
    name: "directions-id",
    path: "/directions/:id()",
    component: () => import("/app/app/pages/directions/[id].vue")
  },
  {
    name: "news-id",
    path: "/news/:id()",
    component: () => import("/app/app/pages/news/[id].vue")
  },
  {
    name: _91id_93EK6Hr25n1MsRwhbZdH3GTKU_PFYvBBOhBvYmJBWLPBAMeta?.name,
    path: "/schools/:id()",
    component: () => import("/app/app/pages/schools/[id].vue"),
    children: [
  {
    name: "schools-id-competitions",
    path: "competitions",
    component: () => import("/app/app/pages/schools/[id]/competitions.vue")
  },
  {
    name: "schools-id-contacts",
    path: "contacts",
    component: () => import("/app/app/pages/schools/[id]/contacts.vue")
  },
  {
    name: "schools-id-directions",
    path: "directions",
    component: () => import("/app/app/pages/schools/[id]/directions.vue")
  },
  {
    name: "schools-id-news",
    path: "news",
    component: () => import("/app/app/pages/schools/[id]/news.vue")
  },
  {
    name: "schools-id-our-pride",
    path: "our-pride",
    component: () => import("/app/app/pages/schools/[id]/our-pride.vue")
  },
  {
    name: "schools-id-reviews",
    path: "reviews",
    component: () => import("/app/app/pages/schools/[id]/reviews.vue")
  },
  {
    name: "schools-id-schedule",
    path: "schedule",
    component: () => import("/app/app/pages/schools/[id]/schedule.vue")
  },
  {
    name: "schools-id-trainers",
    path: "trainers",
    component: () => import("/app/app/pages/schools/[id]/trainers.vue")
  },
  {
    name: "schools-id",
    path: "",
    component: () => import("/app/app/pages/schools/[id]/index.vue")
  }
]
  },
  {
    name: _91id_93JgY_Uh5_rxQnr2Eilk0lfHSnM__jjtiV3pQ0Vsw5IbsMeta?.name,
    path: "/trainers/:id()",
    component: () => import("/app/app/pages/trainers/[id].vue"),
    children: [
  {
    name: "trainers-id-competitions",
    path: "competitions",
    component: () => import("/app/app/pages/trainers/[id]/competitions.vue")
  },
  {
    name: "trainers-id-contacts",
    path: "contacts",
    component: () => import("/app/app/pages/trainers/[id]/contacts.vue")
  },
  {
    name: "trainers-id-directions",
    path: "directions",
    component: () => import("/app/app/pages/trainers/[id]/directions.vue")
  },
  {
    name: "trainers-id-news",
    path: "news",
    component: () => import("/app/app/pages/trainers/[id]/news.vue")
  },
  {
    name: "trainers-id-our-pride",
    path: "our-pride",
    component: () => import("/app/app/pages/trainers/[id]/our-pride.vue")
  },
  {
    name: "trainers-id-reviews",
    path: "reviews",
    component: () => import("/app/app/pages/trainers/[id]/reviews.vue")
  },
  {
    name: "trainers-id-schedule",
    path: "schedule",
    component: () => import("/app/app/pages/trainers/[id]/schedule.vue")
  },
  {
    name: "trainers-id-schools",
    path: "schools",
    component: () => import("/app/app/pages/trainers/[id]/schools.vue")
  },
  {
    name: "trainers-id",
    path: "",
    component: () => import("/app/app/pages/trainers/[id]/index.vue")
  }
]
  },
  {
    name: "directions",
    path: "/directions",
    meta: index8e72ZGJjPgiJMgiXDaIuh7et8YTK5_M4BzWIYum5vQ8Meta || {},
    component: () => import("/app/app/pages/directions/index.vue")
  },
  {
    name: "documents",
    path: "/documents",
    meta: index0vzPtFuUGDClUpww6atMNzl_Qut4EoVknbd44sNBQpUMeta || {},
    component: () => import("/app/app/pages/documents/index.vue")
  },
  {
    name: "news",
    path: "/news",
    meta: indexXMhUAiv3h8Yn9KnrusHDrXg_4CaqSc0YcZdd_ACZy8cMeta || {},
    component: () => import("/app/app/pages/news/index.vue")
  },
  {
    name: "schools",
    path: "/schools",
    meta: indexYHDwlvR2vM4IK9S9aO_lNVjj64cOWSOz0gI_D0ogHjQMeta || {},
    component: () => import("/app/app/pages/schools/index.vue")
  },
  {
    name: "trainers",
    path: "/trainers",
    meta: index5lW_HNdiZ7SeEpDqsYrYEJZucehb7R3AyTcl1Kj5qTEMeta || {},
    component: () => import("/app/app/pages/trainers/index.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/app/app/pages/index.vue")
  }
]